/**
 * Stores — two location cards + MapWidget.
 */
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import LocationCard from "../../components/LocationCard";
import MapWidget from "../../components/MapWidget";

export default function HomeStores({ locations }) {
    return (
        <section className="relative px-6 sm:px-10 py-12 sm:py-16 bg-zen-bg border-t border-zen-ink/8">
            <div className="max-w-[1400px] mx-auto">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8">
                    <div>
                        <p className="text-[11px] uppercase tracking-[0.35em] text-zen-olive mb-4">
                            Visit a store
                        </p>
                        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-zen-ink leading-[1.05] max-w-2xl">
                            Two ZenZest flagships.{" "}
                            <span className="italic text-zen-olive">
                                One quiet philosophy.
                            </span>
                        </h2>
                    </div>
                    <Link
                        to="/locations"
                        data-testid="home-all-locations-link"
                        className="zen-link text-[12px] uppercase tracking-[0.25em] text-zen-ink-soft hover:text-zen-ink self-start md:self-end inline-flex items-center gap-2"
                    >
                        All locations <ArrowUpRight size={14} />
                    </Link>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {locations.map((loc) => (
                        <LocationCard key={loc.slug} location={loc} />
                    ))}
                </div>

                <div className="mt-12">
                    <MapWidget
                        locations={locations}
                        center={[40.69, -73.93]}
                        zoom={10}
                    />
                </div>
            </div>
        </section>
    );
}
